import GlobalStyle from "./GlobalStyles";
import Navbar from "./compoents/Navbar/Navbar";
import Footer from "./compoents/Footer/Footer";
import Home from "./Pages/HomePage/Home";

function App() {
  return (
    <>
      <GlobalStyle />
      <Navbar />
      <Home />
      <Footer />
    </>
  );
}

export default App;
